/* Cart page behaviour: quantity, remove, empty and discount code.
 *
 * Quantity and removal go through /cart/change.js and reload so every total on
 * the page (summary, VAT, free-shipping bar) is rendered by Liquid rather than
 * recalculated twice in two places.
 *
 * Shopify cannot validate a discount code on the cart page, so the code is
 * applied by visiting /discount/CODE, which redirects back with it active.
 */
(function () {
  'use strict';

  document.documentElement.setAttribute('data-ybn-cart', 'ready');

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  function busy(on) {
    var s = document.querySelector('.ybn-cart');
    if (s) s.style.opacity = on ? '0.6' : '';
  }

  function change(line, quantity) {
    busy(true);
    post('/cart/change.js', { line: line, quantity: quantity })
      .then(function () { window.location.reload(); })
      .catch(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-line]');

    if (e.target.closest('[data-cart-remove]') && row) {
      change(parseInt(row.getAttribute('data-line'), 10), 0);
      return;
    }

    if (row && (e.target.closest('[data-cart-dec]') || e.target.closest('[data-cart-inc]'))) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var el = row.querySelector('[data-cart-qty]');
      var qty = parseInt(el ? el.textContent : '1', 10) || 1;
      var next = e.target.closest('[data-cart-dec]') ? qty - 1 : qty + 1;
      change(line, Math.max(0, next));
      return;
    }

    if (e.target.closest('[data-cart-clear]')) {
      busy(true);
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function () { window.location.reload(); })
        .catch(function () { busy(false); });
      return;
    }

    if (e.target.closest('[data-coupon-apply]')) {
      var input = document.querySelector('[data-coupon-input]');
      var code = input ? input.value.trim() : '';
      if (!code) { if (input) input.focus(); return; }
      window.location.href =
        '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
  });

  // Enter in the coupon field should apply rather than do nothing.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches || !e.target.matches('[data-coupon-input]')) return;
    e.preventDefault();
    var btn = document.querySelector('[data-coupon-apply]');
    if (btn) btn.click();
  });
})();
